export default __webpack_public_path__ + "static/media/Features-Overview.a461fddd.svg";